
import {modals} from "@mantine/modals";
import {LinkAction} from "@/types/enums/LinkAction.ts";
import {ILink} from "@/types/models/ILink.ts";
import LinkModal from "@/components/SidebarLinks/LinkModal/modal.tsx";

export const LINK_MODAL_ID = "linkModal"

export function openLinkModal(link: ILink | null = null, deleteLink: boolean = false, onComplete: () => void) {
    let action
    if (link != null && deleteLink) {
        action = LinkAction.DELETE
    } else if (link != null) {
        action = LinkAction.EDIT
    } else {
        action = LinkAction.ADD
    }
    modals.open({
        modalId: LINK_MODAL_ID,
        title: `${action} Link`,
        children: <LinkModal link={link} action={action} onComplete={onComplete}/>
    })
}